import { z } from 'zod'

/***************** 사용자 유형 *****************/
export const USER_TYPE = ['TEACHER', 'STUDENT', 'PARENT'] as const

/***************** 사용자 권한 *****************/
export const USER_AUTHORITY = [
  'ROLE_ROOT_TEACHER',
  'ROLE_MANAGER_TEACHER',
  'ROLE_HOMEROOM_TEACHER',
  'ROLE_PARENT',
  'ROLE_STUDENT',
  'ROLE_INTERNAL',
  'ROLE_EXTERNAL',
] as const

/***************** 학원(요금제) 권한 *****************/
export const ACADEMY_AUTHORITY = ['PREMIUM', 'BASIC', 'SOLO'] as const

export const UserTypeSchema = z.enum(USER_TYPE)
export type UserType = z.infer<typeof UserTypeSchema>

export const UserAuthoritySchema = z.enum(USER_AUTHORITY)
export type UserAuthority = z.infer<typeof UserAuthoritySchema>

export const AcademyAuthoritySchema = z.enum(ACADEMY_AUTHORITY)
export type AcademyAuthority = z.infer<typeof AcademyAuthoritySchema>

// 서버는 사용자 권한과 학원 권한을 한 배열(ServiceAuthority)에 섞어 낸다.
export const ServiceAuthoritySchema = z.union([UserAuthoritySchema, AcademyAuthoritySchema])
export type ServiceAuthority = z.infer<typeof ServiceAuthoritySchema>

// /users/me 응답. 로그인 응답에서 토큰을 뺀 것과 같은 모양이다.
// restrictions 의 값은 기능 차단 키(`mathflat.teacher.cas.*` 등)인데 목록이 길고 자주 바뀌어 여기서는 문자열로 받고
// 해석은 각 앱의 권한 모듈이 한다. 스펙은 optional 로만 그리지만 서버 선언이 List<Restriction>? 이라 null 도 온다.
// 2026-09-18 백엔드 소스(UserResponse.kt)로 확인. 서버가 함께 내는 permissions 는 항상 빈 배열이라 받지 않는다.
export const MeSchema = z.object({
  academyId: z.string(),
  userId: z.string(),
  userType: UserTypeSchema,
  authorities: z.array(ServiceAuthoritySchema),
  restrictions: z.array(z.string()).nullable().optional(),
  passwordChangedRequired: z.boolean(),
})
export type Me = z.infer<typeof MeSchema>
